// SW registration helper. Called once from main.tsx after the app
// boots. We register the production SW path (Vite injects the
// hashed filename via virtual:pwa-register) and silently no-op in dev
// — Vite's HMR + an active service worker is a frustrating pair, so
// the plugin is configured with `devOptions.enabled: false`.
//
// Phase A keeps this small: register, log success, swallow errors.
// Phase D will add the "update available" toast that re-triggers
// skipWaiting + reload.

import { registerSW } from "virtual:pwa-register";

export function registerServiceWorker() {
  // virtual:pwa-register handles the SW path + scope based on the
  // vite-plugin-pwa config. We just call it and react to lifecycle
  // events. immediate:true claims existing tabs as soon as a new SW
  // activates so users don't get stuck on an old build.
  const updateSW = registerSW({
    immediate: true,
    onRegisteredSW(swUrl) {
      // Useful for tracking which build a client is on. Visible in
      // dev tools if you grep for "[sw]".
      console.info("[sw] registered:", swUrl);
    },
    onOfflineReady() {
      console.info("[sw] offline-ready — app shell cached");
    },
    onNeedRefresh() {
      // Phase A: just auto-reload to the new build. Phase D replaces
      // this with a toast so the user can dismiss / "refresh now".
      console.info("[sw] new build available — reloading");
      updateSW(true);
    },
    onRegisterError(err) {
      console.warn("[sw] register failed:", err);
    },
  });
}
